export const otaConnectWizard = {
  google: {
    lead: "نتحقق أولاً من اكتمال بيانات مكان إقامتك: جوجل ليس لديه لوحة تحكم ويعرض فقط ما نرسله إليه.",
    goConnect: "المتابعة في Channex",
    nextIsChannex: "الخطوة الأخيرة — اختيار الغرف والأسعار التي يراها جوجل — تتم في شاشة Channex التي ستُفتح الآن.",
    typeLabel: "ما نوع مكان الإقامة؟",
    hotel: "فندق",
    hotelHint: "بعدة غرف",
    vr: "إقامة عطلات",
    vrHint: "منزل أو شقة كاملة",
    checking: "جاري مراجعة بيانات مكان الإقامة…",
    ready: "كل شيء جاهز: يمكن لجوجل نشره.",
    missing: "ينقص شيء واحد قبل الربط | تنقص {count} أشياء قبل الربط",
    canFix: "لدينا جزء من ذلك محفوظ ويمكننا رفعه نيابة عنك.",
    prepare: "تجهيز البيانات",
    prepareFailed: "تعذّر تجهيز البيانات.",
    checkFailed: "تعذّرت مراجعة البيانات.",
    cancelLabel: "سياسة الإلغاء",
    cancelFree: "إلغاء مجاني",
    cancelNon: "غير قابل للاسترداد",
    bedrooms: "غرف النوم",
    beds: "الأسرّة",
    bathrooms: "الحمامات",
  },
  common: {
    close: "إغلاق",
  },
  intro: {
    imageAlt: "قبل ربط Booking، ضع هذا في الحسبان",
    continue: "فهمت، متابعة",
  },
  header: {
    edit: "تعديل",
    connect: "ربط",
    guidedStep: "مساعد موجَّه · الخطوة {current} من {total}",
  },
  steps: {
    connection: "الاتصال",
    rooms: "الغرف",
    rates: "الأسعار",
    review: "المراجعة",
    done: "تم",
  },
  fields: {
    hotel_id: { label: "معرّف الفندق", hint: "تجده في إكسترانت الـ OTA، أعلى اليمين." },
    hotel_code: { label: "رمز الفندق", hint: "معرّف مبناك في الـ OTA." },
    property_id: { label: "معرّف المبنى", hint: "" },
    listing_id: { label: "معرّف الإعلان", hint: "" },
    property_code: { label: "رمز المبنى", hint: "" },
    username: { label: "اسم المستخدم", hint: "اسم المستخدم للدخول إلى إكسترانت الـ OTA." },
    user: { label: "اسم المستخدم", hint: "اسم المستخدم للدخول إلى إكسترانت الـ OTA." },
    password: { label: "كلمة المرور", hint: "كلمة مرور إكسترانت الـ OTA." },
    api_key: { label: "مفتاح API", hint: "توفّره لك الـ OTA." },
    agent_id: { label: "معرّف الوكيل", hint: "" },
  },
  step0: {
    lead: "الصِق معرّف مبناك في القناة. نتحقق منه فوراً.",
    loadingChannel: "جارٍ تحميل متطلبات القناة…",
    notAvailable: "هذه القناة غير متاحة بعد عبر الربط الموجَّه بالـ API.",
    oauthText: "يرتبط {name} بحسابك عبر تسجيل دخول آمن. عند الضغط نفتح {name} في تبويب آخر لتمنح الإذن؛ وعند عودتك يظهر الاتصال في قنواتك.",
    oauthConnect: "الربط مع {name}",
    oauthOpened: "فتحنا {name} في تبويب آخر. امنح الإذن هناك وسيظهر الاتصال في قنواتك.",
    currencyLabel: "العملة",
    currencyTooltip: "تحددها القناة لمبناك. تُملأ تلقائياً عند التحقق من الاتصال؛ ولا يمكن تعديلها.",
    currencyPlaceholder: "تُملأ عند التحقق",
    currencyDetected: "تم اكتشافها تلقائياً",
    currencyVerifyToDetect: "تحقق من الاتصال لاكتشافها",
    verified: "تم التحقق",
    testConnection: "اختبار الاتصال",
    testOk: "تم التحقق من الاتصال. تابع لمطابقة الغرف والأسعار.",
    testFailedDefault: "تعذّر التحقق من الاتصال. راجع المعرّف.",
  },
  step1: {
    leadAirbnb: "طابِق كل إعلان في Airbnb مع إحدى وحداتك.",
    leadOther: "طابِق كل غرفة في {channel} مع وحدة من إعلانك.",
    listingChip: "الإعلان: {name}",
    noLimitChip: "بلا حدّ على عدد الحسابات أو المباني",
    loadingRooms: "جارٍ تحميل غرف القناة…",
    noRooms: "لم يتم العثور على غرف للمطابقة.",
    dupUnitWarning: "«{unit}» مُخصَّصة لأكثر من غرفة في {channel}. يجب أن تذهب كل غرفة في القناة إلى غرفة مختلفة لديك: إذا حُفظت هكذا، فسيبيعها {channel} جميعاً بالسعر نفسه. صحّح ذلك أدناه قبل المتابعة.",
    searchPlaceholder: "بحث…",
    noRoomMatch: "لا توجد غرفة تطابق «{query}».",
    copied: "تم النسخ",
    copyId: "نسخ المعرّف: {id}",
    rateCountMeta: "{channel} · {count} سعر",
    edit: "تعديل",
    disconnect: "فصل",
    unitSearchPlaceholder: "ابحث عن وحدتك أو إعلانك…",
    noMatch: "لا توجد نتائج",
    cancel: "إلغاء",
  },
  step2: {
    lead: "يُملأ السعر الرئيسي لكل غرفة تلقائياً من سعرك في {channel}. إذا كان للغرفة عدة أسعار، فحدّد نسبة الزيادة (أو الخصم) التي ستفرضها في كل منها.",
    crossedFixed: "كان أحد الأسعار مطابَقاً مع غرفة أخرى، مما قد يجعل {channel} يبيع بالسعر الخطأ. تمت إعادة سعر كل غرفة إليها: راجِعها قبل المتابعة. | كانت {count} أسعار مطابَقة مع غرفة أخرى، مما قد يجعل {channel} يبيع بالسعر الخطأ. تمت إعادة سعر كل غرفة إليها: راجِعها قبل المتابعة.",
    noRates: "لم يتم العثور على أسعار للمطابقة.",
    yourPct: "نسبتك لهذه الغرفة",
    auto: "تلقائي",
    changePct: "تغيير النسبة",
    multiRateAlert: "لهذه الغرفة عدة أسعار. حدّد نسبة الزيادة (أو الخصم) التي ستفرضها على نزلائك في كل منها إذا حجزوا عبر {channel}.",
    minStayOnApply: "يُحفظ عند الضغط على «تطبيق».",
    minStayMissing: "لا يوجد حد أدنى خاص للإقامة: تبيعه {channel} بالحد الأدنى للسعر الرئيسي",
    setMinStay: "تعيين الحد الأدنى للإقامة",
    nights: "{n} ليلة | {n} ليالٍ",
    minNights: "حد أدنى {n} ليلة | حد أدنى {n} ليالٍ",
    minInherited: "حد السعر الرئيسي",
    ownPlanSummary: "سعر وحد أدنى خاصان",
    minStayNotDerived: "لم يُطبَّق الحد الأدنى للإقامة ({nights}): «{rate}» سعر رئيسي ويستخدم حده الأدنى الخاص. لكي تطلب {channel} {nights} على هذا السعر، طبّق نسبة مئوية بدلًا من اختياره.",
  },
  step3: {
    lead: "هذا ما سنربطه في {channel}. راجِعه واضغط ربط.",
    channelCurrency: "عملة القناة:",
    chargesNote: "يُؤخذ تسجيل الوصول/المغادرة والرسوم (التنظيف، إلخ) من إعدادات مبناك.",
  },
  done: {
    titleConnected: "تم ربط {name}!",
    titleUpdated: "تم تحديث {name}!",
    subActive: "القناة نشطة: نقوم بالفعل بمزامنة الأسعار والإتاحة.",
    subPaused: "القناة مرتبطة لكنها متوقفة مؤقتاً. فعّلها لبدء مزامنة الأسعار والإتاحة.",
    subUpdated: "تم تحديث مطابقة القناة بنجاح.",
    notificationSent: "تم إرسال الإشعار",
    syncing: "جارٍ المزامنة…",
    paused: "متوقف مؤقتاً",
    activateTitle: "تفعيل القناة",
    activateDesc: "يبدأ بإرسال الأسعار والإتاحة إلى {channel}.",
    activateBtn: "تفعيل القناة",
    activated: "تم التفعيل",
    loadReservationsTitle: "استيراد الحجوزات المستقبلية",
    loadReservationsDesc: "يجلب إلى WACheckin الحجوزات الموجودة لديك بالفعل في {channel}.",
    imported: "تم الاستيراد",
    extract: "استيراد",
  },
  rates: {
    mainRate: "السعر الرئيسي",
    standardRate: "السعر القياسي",
  },
  rooms: {
    listingFallback: "إعلان {id}",
    unitFallback: "وحدة",
  },
  buttons: {
    back: "رجوع",
    saveChanges: "حفظ التغييرات",
    connect: "ربط",
    finish: "إنهاء",
    continue: "متابعة",
  },
  errors: {
    dupUnit: "الوحدة «{unit}» مُخصَّصة لأكثر من غرفة في {channel}. يجب أن تذهب كل غرفة إلى وحدة مختلفة.",
    crossedBlocked: "يوجد سعر واحد مطابَق مع غرفة أخرى ({list}). ارجع إلى خطوة الأسعار واختر سعر كل غرفة: إذا حُفظ هكذا، فسيبيع {channel} بالسعر الخطأ. | توجد {count} أسعار مطابَقة مع غرفة أخرى ({list}). ارجع إلى خطوة الأسعار واختر سعر كل غرفة: إذا حُفظ هكذا، فسيبيع {channel} بالسعر الخطأ.",
    dupRate: "السعر «{rate}» مطابَق مع أكثر من غرفة في {channel} ({rooms}). يجب أن تحمل كل غرفة سعرها الخاص: إذا حُفظ هكذا، فستُباع بالسعر نفسه.",
    roomJoiner: " و ",
    dupRateFallback: "سعر",
    dupUnitFallback: "هذه الوحدة",
    needRate: "طابِق سعراً واحداً على الأقل قبل الربط.",
    updateFailed: "تعذّر تحديث الاتصال.",
    createFailed: "تعذّر إنشاء الاتصال.",
    unmapFailed: "تعذّر فصل الإعلان.",
    needAirbnbMap: "طابِق إعلاناً واحداً على الأقل مع وحدة.",
    unitNoChannexRate: "الوحدة \"{unit}\" ليس لها سعر بمعرّف في Channex.",
    airbnbSaveFailed: "تعذّر حفظ مطابقات Airbnb.",
    actionFailed: "تعذّر تنفيذ الإجراء.",
    oauthLinkFailed: "تعذّر إنشاء رابط الاتصال.",
    testFailed: "خطأ أثناء اختبار الاتصال.",
    testNoVerify: "لا تتطلب هذه القناة تحققاً مسبقاً.",
    rateCreateFailedNeedStandard: "تعذّر إنشاء السعر. تأكد من أن الوحدة لديها سعر قياسي.",
    rateCreateFailed: "تعذّر إنشاء السعر.",
    minStaySaveFailed: "تم اختيار «{rate}»، لكن تعذّر حفظ حده الأدنى للإقامة ({nights}): يبقى على ما كان عليه.",
  },
};
